define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext) {
    "use strict";
    var OfficeLocations = /** @class */ (function () {
        function OfficeLocations() {
            this.filterByAny = ko.observable("");
            this.canExport = ko.observable(UserContext.hasAccess("Admin,OfficeLocations.Export"));
        }
        OfficeLocations.prototype.init = function () {
            var self = this;
            $("#page-title").text("Locations");
            tools.ajaxGet({
                url: "/OfficeLocations/GetLocationsLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.lookupLists.GridStructures.OfficeLocationStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        OfficeLocations.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/OfficeLocations/GetLocations",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#office-locations-toolbar-template").html()),
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: "OfficeLocation",
                    title: "Office Locations",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                gridId: "tblOfficeLocations",
                showPagerOnTop: false,
                controller: self
            };
            self.mainTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.mainTable.refresh();
            });
        };
        OfficeLocations.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        OfficeLocations.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.mainTable.exportTo();
            }
        };
        OfficeLocations.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("OfficeLocation");
                dataLogs.open("Office Locations logs");
                event.preventDefault();
            }
        };
        OfficeLocations.prototype.savePageSettings = function () {
        };
        return OfficeLocations;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/OfficeLocations/Index")) {
            log.log("Initialize OfficeLocations list");
            $(function () {
                (new OfficeLocations()).init();
            });
        }
    }, 0);
    return OfficeLocations;
});
//# sourceMappingURL=officeLocations.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/officeLocations/officeLocations.js
// module id = 215
// module chunks = 2